



































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import GeneralModule from '@/store/modules/General';
import Table from '@/components/Table/Index.vue';
import Pagination from '@/components/Pagination.vue';
import SubAccountBody from '@/components/Table/SubAccountBody.vue';
import ManageMixin from '@/mixins/Manage.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import DownlineHistoryBody from '@/components/Table/DownlineHistoryBody.vue';
import UserData from '@/data/User';

@Component({
  components: {
    Table,
    Pagination,
    SubAccountBody,
    DownlineHistoryBody,
  },
})
export default class Downline extends Mixins(ManageMixin, ErrorHandleMixin, PaginationMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  userId = this.AuthInstance.user._id;

  username = this.AuthInstance.user.username;

  TableHeadSubAccount = UserData.TableHeadSubAccount;

  TableHeadTran = UserData.TableHeadTran;

  dataList: any = [];

  LoginName = '';

  showPermission = false;

  currentPermission = {};

  showFilterCurrency = false;

  reportCurrency = '';

  historyData = [];

  historyPage = 1;

  currencyRate = {};

  handleShowPermission(id) {
    const { userPermission } = this.AccountInstance.subAccount.find((item) => item._id === id);
    this.showPermission = true;
    this.currentPermission = { ...userPermission };
  }

  async created() {
    await this.fetchSubAccount(this.username);
  }

  async handleSearch() {
    if (!this.LoginName) {
      this.dataList = this.AccountInstance.subAccount;
    } else {
      this.dataList = this.AccountInstance.subAccount
        .filter((v) => v.username.includes(this.LoginName));
    }
  }

  async report(user) {
    this.reportCurrency = user.currency;
    this.historyPage = 1;
    this.currentSelectUser = user._id;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.FetchHistory({
      userId: this.currentSelectUser,
      multicurrency: this.showFilterCurrency,
    });
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      this.pageRenderHistory();
      this.modal.report = true;
    }
  }

  pageRenderHistory() {
    this.historyData = this.AccountInstance.history
      .slice((this.historyPage - 1) * 5, (this.historyPage * 5));
  }

  handlePage(param) {
    this.historyPage += param;
    this.pageRenderHistory();
  }

  async fetchSubAccount(username) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.FetchSubAccount({
      username,
    });
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      this.PaginationDetail.current = 1;
      this.calPagination({
        instance: 'AccountInstance',
        dataKey: 'subAccount',
      });
    }
  }

  editPermission(user) {
    this.modalData.userPermission = user.userPermission
      ? { ...user.userPermission }
      : UserData.initialUserPermission();
    this.currentSelectUser = user._id;
    this.modal.permission = true;
  }

  async submitEditPermission() {
    const { userPermission } = this.modalData;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.UpdatePermission({
      userId: this.currentSelectUser,
      ...userPermission,
    });
    this.GeneralInstance.toggleLoading(false);
    this.alert(res);
  }

  alert(res) {
    const { code } = res;
    if (code === 0) {
      this.modalData = {
        profile: UserData.initialUserInfo(),
        lock: UserData.initialLock(),
        password: UserData.initialPassword(),
        permission: UserData.initialPermission(),
        userPermission: UserData.initialUserPermission(),
      };
    }
    this.modal = UserData.initialModal();
    this.checkError(res);
    this.fetchSubAccount(this.username);
  }
}
